import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, VStack, Heading, Button, HStack } from '@chakra-ui/react';
import { useAuthStore } from '@/stores/authStore';
import { useBirthRecordStore } from '@/stores/birthRecordStore';
import { AppLayout } from '@/components/layout/AppLayout';
import { BirthRecordForm } from '@/components/birthRecord/BirthRecordForm';

/**
 * 出産記録登録・編集ページコンポーネント
 */
const BirthRecordFormPage: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { user } = useAuthStore();
  const { selectedBirthRecord, fetchBirthRecord } = useBirthRecordStore();

  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode && user && id) {
      fetchBirthRecord(id, user.uid);
    }
  }, [isEditMode, user, id, fetchBirthRecord]);

  /**
   * フォーム送信成功時の処理
   */
  const handleSubmitSuccess = () => {
    navigate('/dogs'); // 個体一覧に戻る（後で専用の出産記録一覧ページに変更可能）
  };

  /**
   * キャンセル処理
   */
  const handleCancel = () => {
    navigate(-1);
  };

  // 認証ガードはルート側の ProtectedRoute が担うため、ここでは user は必ず存在する。
  if (!user) return null;

  return (
    <AppLayout>
      <Box maxW="4xl" mx="auto">
        <VStack gap={6} align="stretch">
          {/* ヘッダー */}
          <HStack justify="space-between" flexWrap="wrap" gap={4}>
            <Heading size="xl">{isEditMode ? '出産記録編集' : '出産記録新規登録'}</Heading>
            <HStack gap={2}>
              <Button variant="outline" onClick={handleCancel}>
                キャンセル
              </Button>
            </HStack>
          </HStack>

        {/* フォーム */}
        <Box bg="white" p={8} borderRadius="lg" shadow="md">
          <BirthRecordForm
            userId={user.uid}
            initialData={
              isEditMode && selectedBirthRecord
                ? {
                    id: selectedBirthRecord.id,
                    motherId: selectedBirthRecord.motherId,
                    fatherId: selectedBirthRecord.fatherId,
                    matingDate: selectedBirthRecord.matingDate?.toDate(),
                    birthDate: selectedBirthRecord.birthDate.toDate(),
                    totalPuppies: selectedBirthRecord.totalPuppies,
                    alivePuppies: selectedBirthRecord.alivePuppies,
                    deliveryType: selectedBirthRecord.deliveryType,
                    notes: selectedBirthRecord.notes,
                  }
                : undefined
            }
            onSubmitSuccess={handleSubmitSuccess}
            onCancel={handleCancel}
          />
        </Box>
        </VStack>
      </Box>
    </AppLayout>
  );
};

export default BirthRecordFormPage;
